export default __webpack_public_path__ + "static/media/rewards-active.8007b446.svg";